// ------------------------------------
// Upsell
// ------------------------------------
(function () {
  'use strict';

  const $upsellBtn = $('#co-upsell-btn');

  if ($upsellBtn.length > 0) {
    // Variáveis
    const $attributes = $('.upsell-attributes');
    const $upsellError = $('.upsell-error');
    const $variants = $('[data-variants]');
    const $images = $('[data-images]');
    const images = $images.data('images');
    const variants = $variants.data('variants');
    const $variant = $('#co-upsell-variant');
    const $upsellID = $('#co-upsell-id');
    const $upsellCardHash = $('#co-card-hash');
    const $upsellOrder = $('#co-upsell-order');
    const $upsellStoreToken = $('#co-store-token');
    const $upsellProd = $('#co-upsell-prod');
    const $upsellQtde = $('#co-upsell-quantity');
    const $obImg = $('.upsell-prod-image img');
    const $obSubtitle = $('.upsell-prod-subtitle');
    const $modalCVV = $('.modal-cvv');
    const $campoCVV = $modalCVV.find('#campo-cvv');
    const $btnConfCVV = $modalCVV.find('.btn-confirm-cvv');
    let variant;
    let cvvCode;
    let cvvConfirmation = $modalCVV.data('enable') == 'true' || $modalCVV.data('enable') == '1';
    const upsellCcData = JSON.parse($('#co-upsell-cc').val()) || [];

    // Ao clicar para comprar
    $upsellBtn.on('click', handleUpsell);

    function handleUpsell() {
      if (verificaAtributos()) {
        hideUsError();
        if (cvvConfirmation) {
          showModalCVV();
        } else {
          buyUpsell();
        }
      } else {
        $upsellBtn.prop('disabled', true);
        showUsError('Selecione as opções para o produto.');
      }
    }

    // Desabilita o botão principal
    let btnUpsellText = $('.upsell-btn .btn').html();
    function disableUpsellBtn() {
      $('.upsell-btn .btn').prop('disabled', true).addClass('btn-loader').text('Aguarde');
    }

    // Habilita o botão principal
    function enableUpsellBtn() {
      $('.upsell-btn .btn').prop('disabled', false).removeClass('btn-loader').html(btnUpsellText);
    }

    $attributes.find('.form-input').on('change', function () {
      const $input = $(this);
      if (verificaAtributos()) {
        hideUsError();
      }
    });

    function disableAttrUpsell() {
      $attributes.find('.form-input').each(function () {
        $(this).addClass('disabled');
      });
    }

    function showUsError(error) {
      $upsellError.find('li').html(error);
      $upsellError.show();
    }

    function hideUsError(error) {
      $upsellError.find('li').html('');
      $upsellError.hide();
    }

    function verificaAtributos() {
      let empty = 0;
      $attributes.find('.form-input').each(function () {
        const $input = $(this);
        if ($input.val() === '') {
          empty++;
        }
      });
      return empty === 0;
    }

    // ------------------------------------
    // Adiciona o Upsell ao pedido
    // ------------------------------------
    function buyUpsell() {
      disableAttrUpsell();
      showLoader();

      // Variáveis
      const upsellID = $upsellID.val();
      const upsellOrder = $upsellOrder.val();
      const upsellStoreToken = $upsellStoreToken.val();
      const upsellProd = $upsellProd.val();
      const upsellVariant = $variant.val();
      const upsellQtde = $upsellQtde.val();
      const upsellCardHash = $upsellCardHash.val();
      const urlUpsell = urlBase + 'core/acoes/checkout/order_upsell.php';
      const type = 'post';

      // Processa o formulário
      const data = {
        upsell: upsellID,
        product: upsellProd,
        variant: upsellVariant,
        quantity: upsellQtde,
        order: upsellOrder,
        store_token: upsellStoreToken,
        cvv: cvvCode,
        card_hash: upsellCardHash,
        lp_url: urlBaseLp,
      };
      $.ajax({
        url: urlUpsell,
        type: type,
        data: data,
        cache: false,
      })
        .done(function (result) {
          hideLoader();
          modalClose($modalCVV.attr('id'));
          console.log(result);
          result = JSON.parse(result);
          if (result.status === 'success') {
            $upsellBtn.hide();
            $('.upsell-btn-skip').hide();
            showAlert('Parabéns!', 'Compra realizada com sucesso.', 'success');
            setTimeout(() => {
              location.href = result.payment_url;
            }, 3000);
          } else if (result.status === 'error') {
            showAlert('Erro', result.message, 'danger');
          } else {
            showAlert('Erro', 'Não foi possível realizar a compra.', 'danger');
          }
        })
        .fail(function (xhr, status, exception) {
          hideLoader();
          console.log(exception);
          console.log('Não foi possível realizar a compra.');
          showAlert('Erro', 'Não foi possível realizar a compra.', 'danger');
        });
    }

    $('.upsell-attributes .form-input').on('change', function () {
      if ($(this).hasClass('form-input-kit')) {
        showVariantInfos('', $(this).val());
      } else {
        getAttrVariant();
      }
    });

    // Retorna o slug da variante com base nos atributos selecionados
    function getAttrVariant() {
      let variantSlug = [];
      $('.upsell-attributes .form-input').each(function () {
        const $input = $(this);
        //const attrName = $input.attr('name');
        const attrName = $input.data('name');
        const attrValue = slugify($input.val());
        variantSlug.push(attrName + ':' + attrValue);
      });
      variantSlug = variantSlug.join('|');
      showVariantInfos(variantSlug);
    }

    // Exibe as informações da variante selecionada
    function showVariantInfos(variantSlug, variantSKU = false) {
      if (variantSKU) {
        variant = getVariantBySKU(variantSKU);
      } else {
        variant = getVariant(variantSlug);
      }
      if (variant !== undefined) {
        //console.log(variant);
        console.log('Variante: ' + variant.sku);
        // SKU
        $variant.val(variant.sku);
        // Imagem
        const obImage = getImgVariant(variant.image_id);
        if (obImage) {
          //$obImg.attr('src', obImage.image);
          $obImg.attr('src', obImage.thumb);
        }
        // Subtítulo (Informação da variante)
        $obSubtitle.text(variant.title_view);
        // Verifica disponibilidade
        if (variant.automatic_stock == '1' && variant.quantity == 0) {
          $upsellBtn.prop('disabled', true);
          showUsError('Opção indisponível! Selecione uma opção diferente.');
        } else {
          $upsellBtn.prop('disabled', false);
          hideUsError();
        }
      }
    }

    // Retorna uma variante com base no slug
    function getVariant(variantSlug) {
      return variants.filter((item) => item.slug == variantSlug)[0];
    }

    // Retorna uma variante com base no SKU
    function getVariantBySKU(variantSKU) {
      return variants.filter((item) => item.sku == variantSKU)[0];
    }

    // Retorna a imagem da variante
    function getImgVariant(imageID) {
      return images.filter((item) => item.id == imageID)[0];
    }

    // Modal CVV

    // Ao digitar o código
    $campoCVV.on('input', function () {
      let cvv = $(this).val();
      if (cvv && cvv.length >= 3) {
        $btnConfCVV.prop('disabled', false);
      } else {
        $btnConfCVV.prop('disabled', true);
      }
    });

    // Ao clicar no botão para confirmar
    $btnConfCVV.on('click', function (ev) {
      ev.preventDefault();
      cvvCode = $campoCVV.val();
      getMercadoPagoCardToken(buyUpsell);
    });

    // Ao pressionar Enter no campo
    $campoCVV.on('keyup', function (ev) {
      if (ev.which === 13) {
        let cvv = $campoCVV.val();
        if (cvv && cvv.length >= 3) {
          getMercadoPagoCardToken(buyUpsell);
        }
      }
    });

    // Exibe o modal CVV
    function showModalCVV() {
      modalOpen($modalCVV.attr('id'));
    }

    // Valida as informações do cartão
    function validateCardInfos(brand = true) {
      const cardNumber = somenteNumeros(upsellCcData['card_number']);
      const cardMonth = upsellCcData['card_month'];
      const cardYear = upsellCcData['card_year'];
      const cardCVV = upsellCcData['card_cvv'];
      const cardBrand = upsellCcData['card_brand'];
      if (brand) {
        return (
          cardNumber &&
          cardNumber.length >= 6 &&
          cardBrand &&
          cardBrand != '' &&
          cardMonth &&
          cardMonth.length === 2 &&
          cardYear &&
          cardYear.length > 1 &&
          cardCVV &&
          cardCVV.length >= 3
        );
      }
      return (
        cardNumber &&
        cardNumber.length >= 6 &&
        cardMonth &&
        cardMonth.length === 2 &&
        cardYear &&
        cardYear.length > 1 &&
        cardCVV &&
        cardCVV.length >= 3
      );
    }

    // ------------------------------------
    // Mercado Pago
    // ------------------------------------
    // Inicia o Mercado Pago
    if (typeof Mercadopago != 'undefined') {
      initMercadopago();
    }
    function initMercadopago() {
      getMercadoPagoToken();
    }
    // Obtém o token
    function getMercadoPagoToken() {
      const urlSession = urlBase + 'core/acoes/checkout/mercadopago_get_session.php';
      $.getJSON(
        `${urlSession}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
        function (result) {
          //console.log(result);
          Mercadopago.setPublishableKey(result.mp_token);
        },
      ).fail(function (result) {
        console.log(result);
      });
    }
    // Obtém o token do cartão
    function getMercadoPagoCardToken(callback = null) {
      Mercadopago.createToken($('#form-cvv')[0], function (status, response) {
        //console.log(response);
        if (status == 200 || status == 201) {
          $('#co-card-hash').val(response.id);
          if (callback) {
            callback();
          }
        } else {
          console.log(response);
          showAlert('Erro', 'Não foi possível realizar a compra.', 'danger');
        }
      });
    }

    // ------------------------------------
    // Abmex
    // ------------------------------------

    // Inicia
    if (typeof AbmexPay != 'undefined' && !previewMode) {
      initAbmex();
    }
    function initAbmex() {
      getAbmexToken();
    }

    // Obtém o token da api
    function getAbmexToken() {
      const urlSession = urlBase + 'core/acoes/checkout/abmex_get_session.php';
      $.getJSON(`${urlSession}?store_token=${storeToken}`, function (result) {
        //console.log(result);
        if (result.token) {
          AbmexPay.setPublicKey(result.token);
          //AbmexPay.setTestMode(true);
          setTimeout(() => {
            getAbmexCardToken();
          }, 500);
        } else {
          console.log('Não foi possível obter o token de api da Abmex.');
        }
      }).fail(function (result) {
        console.log(result);
      });
    }

    // Obtém o token do cartão
    function getAbmexCardToken() {
      if (validateCardInfos(false)) {
        disableUpsellBtn();
        const cardName = upsellCcData['card_name'];
        const cardNumber = Number(somenteNumeros(upsellCcData['card_number']));
        const cardMonth = Number(upsellCcData['card_month']);
        const cardYear = Number(upsellCcData['card_year']);
        const cardCVV = upsellCcData['card_cvv'];
        const data = {
          number: cardNumber,
          holderName: cardName,
          expMonth: cardMonth,
          expYear: cardYear,
          cvv: cardCVV,
        };
        AbmexPay.encrypt(data)
          .then((cartToken) => {
            console.log('cardToken: ', cartToken);
            $upsellCardHash.val(cartToken);
            enableUpsellBtn();
          })
          .catch((err) => {
            console.error(err);
            enableUpsellBtn();
          });
      }
    }

    // ------------------------------------
    // DOM
    // ------------------------------------

    // Inicia o Dom
    if (typeof DomPagamentos != 'undefined' && !previewMode) {
      initDom();
    }
    function initDom() {
      getDomToken();
    }

    // Obtém o token
    function getDomToken() {
      const urlSession = urlBase + 'core/acoes/checkout/dom_get_session.php';
      $.getJSON(`${urlSession}?store_token=${storeToken}`, function (result) {
        console.log(result);
        DomPagamentos.setPublicKey(result.token);
        //DomPagamentos.setTestMode(true);
        setTimeout(() => {
          getDomCardToken();
        }, 500);
      }).fail(function (result) {
        console.log(result);
      });
    }

    // Obtém o token do cartão
    function getDomCardToken() {
      if (validateCardInfos(false)) {
        disableUpsellBtn();
        const cardName = upsellCcData['card_name'];
        const cardNumber = Number(somenteNumeros(upsellCcData['card_number']));
        const cardMonth = Number(upsellCcData['card_month']);
        const cardYear = Number(upsellCcData['card_year']);
        const cardCVV = upsellCcData['card_cvv'];
        const data = {
          number: cardNumber,
          holderName: cardName,
          expMonth: cardMonth,
          expYear: cardYear,
          cvv: cardCVV,
        };
        DomPagamentos.encrypt(data)
          .then((cartToken) => {
            console.log('cardToken: ', cartToken);
            $upsellCardHash.val(cartToken);
            enableUpsellBtn();
          })
          .catch((err) => {
            console.error(err);
            enableUpsellBtn();
          });
      }
    }

    // ------------------------------------
    // PAGOU AI
    // ------------------------------------

    // Inicia o Pagou Ai
    if (typeof Pagouai != 'undefined' && !previewMode) {
      initPagouai();
    }
    function initPagouai() {
      getPagouaiToken();
    }

    // Obtém o token
    function getPagouaiToken() {
      const urlSession = urlBase + 'core/acoes/checkout/pagouai_get_session.php';
      $.getJSON(`${urlSession}?store_token=${storeToken}`, function (result) {
        console.log(result);
        Pagou.setPublicKey(result.token);
        //Pagouai.setTestMode(true);
        setTimeout(() => {
          getPagouaiCardToken();
        }, 500);
      }).fail(function (result) {
        console.log(result);
      });
    }

    // Obtém o token do cartão
    function getPagouaiCardToken() {
      if (validateCardInfos(false)) {
        disableUpsellBtn();
        const cardName = upsellCcData['card_name'];
        const cardNumber = Number(somenteNumeros(upsellCcData['card_number']));
        const cardMonth = Number(upsellCcData['card_month']);
        const cardYear = Number(upsellCcData['card_year']);
        const cardCVV = upsellCcData['card_cvv'];
        const data = {
          number: cardNumber,
          holderName: cardName,
          expMonth: cardMonth,
          expYear: cardYear,
          cvv: cardCVV,
        };
        Pagou.encrypt(data)
          .then((cartToken) => {
            console.log('cardToken: ', cartToken);
            $upsellCardHash.val(cartToken);
            enableUpsellBtn();
          })
          .catch((err) => {
            console.error(err);
            enableUpsellBtn();
          });
      }
    }

  }
})();
